import { Project } from '~screens/Dashboard/screens/Projects/types';
import api from '../config/api';

export interface Country {
    id: number;
    name: string;
    flag?: string;
}

export interface Route {
    id: number;
    name: string;
    description: string;
    countries: Country;
    countriesFormatted: string;
    kmz: string;
    totalInvestmentFormatted: string;
    projects: number;
    uuid: string;
    projectsList?: Project[];
    ajusteMapa?: {
        latitude: string,
        longitude: string,
        zoom: number
    }
}


export const getRoutes = () => api.get('/routes/all').then(response => {
    return response.data as Route[];
}); // eslint-disable-line camelcase

// The Ruta map asks for the same route several times at once (list, title, geometry); share one request.
const pendingRouteProjects: { [routeId: string]: Promise<Route> } = {};

export const getRouteProjects = (routeId: number | string): Promise<Route> => {
    const key = String(routeId);
    if (!pendingRouteProjects[key]) {
        const clear = () => {
            delete pendingRouteProjects[key];
        };
        pendingRouteProjects[key] = api.get(`/routes/${routeId}/projects/`).then(response => {
            clear();
            return response.data as Route;
        }, error => {
            clear();
            throw error;
        });
    }
    return pendingRouteProjects[key];
};